import { useTranslations } from "next-intl";
import {
  CheckedLabel,
  FormDatePicker,
  FormInput,
  FormSelect,
  Iconify,
} from "..";
import {
  DatePickerElement,
  MultiSelectElement,
  SelectElement,
  useFormContext,
  useWatch,
} from "react-hook-form-mui";
import { OutlinedInput, useTheme } from "@mui/material";
import parseWithOptions from "date-fns/fp/parseWithOptions";

export type WeekDays =
  | "sunday"
  | "monday"
  | "tuesday"
  | "wedneday"
  | "thursday"
  | "friday"
  | "saturday";

interface WeekDayPickerProps {
  name: string;
  mode: "day" | "week" | "month";
  isMultiple?: boolean;
}

export const WeekDayPicker = ({ name, mode = "day" }: WeekDayPickerProps) => {
  const t = useTranslations();
  const theme = useTheme();
  const { control } = useFormContext();
  const value = useWatch({ name, control });

  const options = [
    { id: "sunday", label: t("common.sunday") },
    { id: "monday", label: t("common.monday") },
    { id: "tuesday", label: t("common.tuesday") },
    { id: "wednesday", label: t("common.wednesday") },
    { id: "thursday", label: t("common.thursday") },
    { id: "friday", label: t("common.friday") },
    { id: "saturday", label: t("common.saturday") },
  ];

  if (mode === "month")
    return (
      <FormDatePicker
        views={["day"]}
        slotProps={{
          field: {
            InputProps: {
              sx: {
                maxWidth: "6rem",
                "& input": {
                  paddingRight: 0,
                  textAlign: "right",
                },

                "& fieldset": { border: "none", fontWeight: 500 },
                color: theme.palette.primary.main,
                fontWeight: 500,
                "& .MuiIconButton-root": value && {
                  color: theme.palette.primary.main,
                  paddingLeft: 0,
                },
              },
            } as any,
          },
        }}
        sx={{
          maxWidth: "2rem",
          color: theme.palette.primary.main,

          textTransform: "capitalize",
          bgcolor: "grey.300",
          border: "none",

          "& fieldset": { border: "none" },
        }}
        name={name}
      />
    );

  return (
    <MultiSelectElement
      showCheckbox
      IconComponent={(prop) => (
        <Iconify
          icon="gravity-ui:calendar"
          fontSize="1.3rem"
          {...prop}
          color={
            value?.length > 0
              ? `${theme.palette.primary.main} !important`
              : "grey.200 !important"
          }
          sx={{ transform: "none !important" }}
        />
      )}
      size="small"
      sx={{
        minWidth: "15rem",
        textTransform: "capitalize",
        bgcolor: "grey.300",
        color: theme.palette.primary.main,
        fontWeight: 500,
        maxWidth: "25rem",

        "& fieldset": { border: "none" },

        "& .MuiMenuItem-root": {
          display: "flex",
          flexDirection: "row-reverse",
          fontWeight: 500,
        },
        "& .MuiTypography-root": {
          fontWeight: 500,
        },
        "& .MuiPaper-root": {
          maxWidth: "10rem",
        },
      }}
      name={name}
      inputProps={{
        color: theme.palette.primary.main,
      }}
      displayEmpty
      MenuProps={{
        disablePortal: true,
        variant: "menu",

        PaperProps: {
          elevation: 1,
          sx: { borderRadius: 2 },
        },
        MenuListProps: {
          sx: { fontWeight: 700 },
        },
        sx: {
          textTransform: "capitalize",
          maxWidth: "10rem",

          "& .Mui-selected": {
            backgroundColor: "transparent",
            color: theme.palette.primary.main,
          },
        },
      }}
      options={options}
    />
  );
};
